import { mapState } from "vuex";
import { env } from "@/firebase";
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import { updateDoc, doc } from "firebase/firestore";
import { db } from "@/firebase";
export const onboarding = {
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      accounts: (state) => state.accounts.accounts,
      workspace: (state) => state.workspace.workspace,
      brand: (state) => state.workspace.brand,
      categories: (state) => state.posts.categories,
    }),
  },
  data() {
    return {
      linkedin_accounts: [],
      dialog: false,
      generating_categories: false,
      analyzing_brand: false,
      saving_categories: false,
      fetching_accounts: false,
    };
  },
  methods: {
    async combineCategories() {
      console.log("Combine categories");
      const combineCategories = httpsCallable(functions, "combineCategories", {
        timeout: 900000,
      });
      const res = await combineCategories({
        workspace: this.workspace.uid,
        categories: this.categories.filter((c) => c.selected),
      });
      console.log(res);
      this.$store.commit("setNotification", {
        show: true,
        text: "Categories combined successfully",
        type: "primary",
        icon: "",
      });
      this.$store.dispatch("fetchCategories");
    },
    async connectLinkedin() {
      console.log(env);
      let callback = `${window.location.origin}${this.$route.path}`;
      let url = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=78n0m2kmusm1z2&redirect_uri=${callback}&scope=r_organization_admin%20r_organization_social%20w_organization_social`;
      window.open(url, "_self");
    },
    async selectAccount(account) {
      console.log(account);
      this.linkedin_accounts = [{ ...account, selected: true }];
      this.addAccounts();
    },
    async addAccounts() {
      this.$store.commit("setLoading", { type: "general", val: true });
      console.log(this.linkedin_accounts);
      const addOrganizations = httpsCallable(functions, "addOrganizations");
      const res = await addOrganizations({
        organizations: this.linkedin_accounts.filter((a) => a.selected),
      });
      console.log(res);
      this.dialog = false;
      this.$store.commit("setNotification", {
        show: true,
        text: "LinkedIn account added",
        type: "primary",
        icon: "",
      });
      await this.$store.dispatch("fetchAccounts");
      this.step = 2;
      this.$store.commit("setLoading", { type: "general", val: false });

      await this.analyzeBrand();
      this.save();
    },
    async generateCategories() {
      this.generating_categories = true;
      this.$store.commit("setLoading", { type: "categories", val: true });
      const suggestCategories = httpsCallable(functions, "suggestCategories", {
        timeout: 900000,
      });
      try {
        const res = await suggestCategories({
          first_time: true,
          workspace: this.workspace.uid,
        });
        console.log(JSON.parse(res.data).categories);
      } catch (error) {
        console.log(error);
        this.$store.commit("setLoading", { type: "categories", val: false });
        this.$store.commit("setNotification", {
          show: true,
          text: "Something went wrong while generating categories",
          type: "error",
          icon: "",
        });
      } finally {
        this.$store.dispatch("fetchCategories");
        this.$store.commit("setLoading", { type: "categories", val: false });

        this.$store.commit("setNotification", {
          show: true,
          text: "Categories generated successfully",
          type: "primary",
          icon: "",
        });
        this.generating_categories = false;
      }
    },
    async save() {
      await updateDoc(doc(db, "workspaces", this.workspace.uid), {
        brand: this.brand,
      });
      this.$store.commit("setNotification", {
        show: true,
        text: "Brand saved",
        type: "primary",
        icon: "",
      });
    },
    async analyzeBrand() {
      this.analyzing_brand = true;
      const analyzeBrand = httpsCallable(functions, "analyzeBrand", {
        timeoutSeconds: 300,
      });
      let res = await analyzeBrand({
        input: this.brand.website,
        previous_posts:
          this.accounts.length > 0
            ? this.accounts[0]?.feed?.elements?.map((p) => p.commentary)
            : [],
      });
      console.log(res.data);
      this.brand = {
        ...this.brand,
        ...res.data,
      };
      this.analyzing_brand = false;
    },
  },
  async mounted() {
    console.log("query", this.$route.query);

    let callback = `${window.location.origin}${this.$route.path}`;

    if (this.$route.query.code) {
      this.$store.commit("setLoading", { type: "general", val: true });
      const linkedinAccessToken = httpsCallable(
        functions,
        "linkedinAccessToken",
      );
      this.fetching_accounts = true;

      let response;

      try {
        response = await linkedinAccessToken({
          access_token: this.$route.query.code,
          redirect_uri: callback,
        });
        console.log(response);
        this.dialog = true;
        this.linkedin_accounts = response.data;
        this.fetching_accounts = false;
        this.$store.commit("setLoading", { type: "general", val: false });
      } catch (error) {
        console.log(error);
        this.$store.commit("setLoading", { type: "general", val: false });
        this.$store.commit("setNotification", {
          show: true,
          text: "Something went wrong while allowing access to your LinkedIn account.",
          type: "error",
        });
        this.fetching_accounts = false;
      }
    }
  },
};
